<template>
  <div class="fade-in">
    <div class="container ml2">
      <h1 class="title">Error</h1>
      An error occurred. {{ active }}
    </div>
  </div>
</template>

<script>
export default {
  name: "error",

  data() {
    return {
      active: this.$access()
    };
  }
};
</script>

<style scoped></style>
